<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['item.no']" placeholder="business.label.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.name']" placeholder="business.label.itemName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['location.no']" placeholder="business.label.locationNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['container.no']" placeholder="business.label.containerNo" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.unlock" icon="vxe-icon-rotate-right" status="success" @click="unlock"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName"/>
        <vxe-column field="owner.name" title="business.label.ownerName" width="120"/>
        <vxe-column field="pack.specification" title="business.label.specification"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
        <vxe-column field="lot.no" title="business.label.lot"/>
        <vxe-column field="batch.no" title="business.label.batchNo"/>
        <vxe-column field="location.no" title="business.label.location"/>
        <vxe-column field="inventory.availableQuantity" title="business.label.availableQuantity"/>
        <vxe-column field="inventory.quantity" title="business.label.quantity"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:inventoryStates}" field="inventory.inventoryState" title="business.label.inventoryStatus" width="100"/>
        <vxe-column field="inventory.availableOutboundQuantity" title="business.label.availableOutboundQuantity"/>
        <vxe-column field="inventory.lockedQuantity" title="business.label.lockedQuantity"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.lock" icon="vxe-icon-lock" status="danger" @click.stop="lock(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <InventoryLockConfirmModal ref="inventoryLockConfirmModal" @success="fetch"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import InventoryLockConfirmModal from '@/views/operation/inventory_lock/InventoryLockConfirmModal.vue'

export default {
  name: 'InventoryLockingTable',
  components: { InventoryLockConfirmModal },
  props: {
    inventoryStates: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'item.no': '',
        'item.name': '',
        'location.no': '',
        'container.no': '',
        'locked': false
      }
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('inventoryFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'item.no': '',
        'item.name': '',
        'location.no': '',
        'container.no': '',
        'locked': false
      }
      this.refresh()
    },
    lock(row) {
      this.$refs.inventoryLockConfirmModal.open(row)
    },
    unlock() {
      this.$emit('unlock')
    }
  }
}
</script>